import React, { Component } from "react";
import validator from 'validator';

import ArtifactList from "./ArtifactList";
import ConfirmModal from "../../components/Modals/Confirm";
import ManageModal from "./ManageModal";

import ExhibitsAPI from "../../api/exhibits";
import ArtifactsAPI from "../../api/artifacts";

class Artifacts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      artifacts: [],
      showConfirmModal: false,
      selectedArtifactID: "",
      showManageModal: false,
      types: [],
      saving: false,
      form: {
        title: { value: "", isValid: true, message: "" },
        file: { value: "", isValid: true, message: "" },
        selectedType: { value: "", isValid: true, message: "" },
        videoSrc: { value: '', isValid: true, message: ''},
      }
    };
  }

  componentDidMount() {
    this.getArtifacts();
    ArtifactsAPI.getTypes().then(result =>
      this.setState({ types: result.data })
    );
  }

  getArtifacts = () => {
    ExhibitsAPI.getArtifacts(this.props.match.params.id).then(result =>
      this.setState({ artifacts: result.data })
    );
  };

  toggleConfirmModal = (id = "") => {
    const { showConfirmModal } = this.state;
    this.setState({
      selectedArtifactID: id,
      showConfirmModal: !showConfirmModal
    });
  };

  deleteArtifact = () => {
    const { selectedArtifactID } = this.state;

    ArtifactsAPI.deleteArtifact(selectedArtifactID).then(() => {
      this.getArtifacts();
      this.toggleConfirmModal();
    });
  };

  toggleManageModal = (id = "", title = "", file = "") => {
    const { showManageModal } = this.state;
    if (showManageModal) {
      this.clearForm();
    }
    this.setState({
      selectedArtifactID: id,
      showManageModal: !showManageModal
    });
  };

  onChange = e => {
    const state = this.state;

    switch (e.target.name) {
      case "file":
        state.form.file.value = e.target.files[0];
        break;
      default:
        state.form[e.target.name].value = e.target.value;
        break;
    }

    this.setState({ state });
  };

  onSubmit = e => {
    const { form } = this.state;
    const exhibitID = this.props.match.params.id;

    if (!this.validateForm()) return;

    this.setState({ saving: true });

    ArtifactsAPI.add(
      exhibitID,
      form.selectedType.value,
      form.title.value,
      form.file.value,
      form.videoSrc.value
    ).then(result => {
      this.toggleManageModal();
      this.getArtifacts();
      this.setState({ saving: false });
    });
  };

  validateForm = () => {
    const { form } = this.state;
    let formIsGood = true;

    // reset validation states before performing validation
    Object.keys(form).map((key) => {
      if (form[key].hasOwnProperty('isValid')) {
        form[key].isValid = true;
        form[key].message = '';
      }
    });

    if (form.title.value === "") {
      form.title.isValid = false;
      form.title.message = "Title cannot be empty";
      formIsGood = false;
    }

    if (form.selectedType.value === "") {
      form.selectedType.isValid = false;
      form.selectedType.message = "You must select a type";
      formIsGood = false;
    }

    if (form.file.value === "" && (form.selectedType.value == 1 || form.selectedType.value == 2)) {
      form.file.isValid = false;
      form.file.message = "You must select a file";
      formIsGood = false;
    }

    if (form.selectedType.value == 3 && !validator.isURL(form.videoSrc.value)) {
      form.videoSrc.isValid = false;
      form.videoSrc.message = "You must supply a valid URL";
      formIsGood = false;
    }

    this.setState({ form });

    return formIsGood;
  };

  clearForm = () => {
    const { form } = this.state;

    Object.keys(form).map((key) => {
      form[key].value = "";
      form[key].isValid = true;
      form[key].message = '';
    });
  }

  render() {
    const {
      artifacts,
      showConfirmModal,
      showManageModal,
      form,
      types,
      saving
    } = this.state;

    return (
      <div>
        <ConfirmModal
          show={showConfirmModal}
          title="Confirm Delete"
          toggle={this.toggleConfirmModal}
          confirm={this.deleteArtifact}
        >
          Are you sure you want to delete this artifact?
        </ConfirmModal>

        <ManageModal
          show={showManageModal}
          title={form.title}
          file={form.file}
          videoSrc={form.videoSrc}
          selectedType={form.selectedType}
          types={types}
          toggle={this.toggleManageModal}
          onChange={this.onChange}
          onSubmit={this.onSubmit}
          saving={saving}
        />

        <p>
          <button className="btn btn-primary" onClick={this.toggleManageModal}>
            <i className="fa fa-plus-circle" /> Add Artifact
          </button>
        </p>

        <div className="alert alert-warning">
          <strong><i className="fa fa-exclamation-circle" /></strong>&nbsp;
          Editing existing artifact records is not currently supported. If you need to make a change, delete the existing
          record and create a new one.
        </div>

        <ArtifactList
          artifacts={artifacts}
          deleteArtifact={this.toggleConfirmModal}
        />
      </div>
    );
  }
}

export default Artifacts;



// WEBPACK FOOTER //
// ./src/pages/Artifacts/index.jsx